<!-- 
**** Author: Vishnu Vardhan G
**** Module: Drag and Drop Report Builder
-->
<template>
  <div class="call-chart-container">
    <div class="Chart">
      <h4 style="text-align: center">{{ name }}</h4>
      <doughnut-chart :data="dataPoints" :style="myStyles" />
    </div>
  </div>
</template>

<script>
import DoughnutChart from "./js/DoughnutChart";
export default {
  components: {
    DoughnutChart,
  },
  props: {
    timer: {
      type: Number,
      default: 10000,
    },
    id: {
      type: Number,
      default: 1,
    },
    name: {
      type: String,
      default: "",
      validator: function (val) {
        return typeof val === "string";
      },
    },
  },
  data() {
    return {
      dataPoints: {},
      height: 20,
      polling: null,
    };
  },
  created() {
    const scope = this;
    const payload = {
      id: scope.id,
      skip: 0,
      take: 20,
    };
    scope.$store
      .dispatch("rect/renderWidgetData", payload)
      .then((result) => {
        scope.dataPoints = JSON.parse(JSON.stringify(result));
      })
      .catch((err) => {
        console.log("Error(Doughnut) ==>", err);
      });
    scope.fillData();
  },
  methods: {
    increaseHeight() {
      this.height += 10;
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    fillData() {
      const scope = this;
      scope.polling = setInterval(() => {
        const payload = {
          id: scope.id,
          skip: 0,
          take: 20,
        };
        scope.$store
          .dispatch("rect/renderWidgetData", payload)
          .then((result) => {
            scope.dataPoints = JSON.parse(JSON.stringify(result));
          })
          .catch((err) => {
            console.log("Error(Doughnut) ==>", err);
          });
      }, scope.timer);
    },
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  computed: {
    myStyles() {
      return `height: 90%;width: 100%;position: relative;`;
    },
  },
};
</script>

<style>
.call-chart-container {
  width: 100%;
  height: 100%;
  display: flex !important;
  position: relative;
}

h1 {
  font-family: "Helvetica", Arial;
  color: #464646;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 5px;
  font-size: 18px;
  margin-top: 0;
}

.call-chart-container .Chart {
  position: absolute;
  padding: 5px;
  width: 100%;
  height: 100%;
  margin: auto;
  box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.4);
}
</style>
